import React from 'react';

const TopAlbums = ({ albums }) => {
  if (!albums) return null;

  return (
    <div className="card">
      <div className="card-heading">
        <h1>albums</h1>
        <span className="num">N° 05</span>
      </div>
      <div className="card-content">
        <ol>
          {albums.slice(0, 25).map(album => (
            <li key={album.name}>
              <span className="track-name">{album.name}</span>
              <span className="plays-count">{album.playcount}</span>
            </li>
          ))}
        </ol>
      </div>
    </div>
  );
};

export default TopAlbums;
